import { ShopOnboardingCategory, ShopOnboardingID } from '@prisma/client';
import { OnboardingModalCategory } from '../types/businesses';
import { ROUTES } from './global';
import { ShopTab } from '../routes/ShopPage';

const constructPath = (route: string, params?: Record<string, string>) => {
  if (!params) return route;
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    searchParams.set(key, value);
  });
  return `${route}?${searchParams.toString()}`;
};

export const ONBOARDING_STEPS_ROUTES: Record<ShopOnboardingID, string> = {
  [ShopOnboardingID.LOCATION]: constructPath(ROUTES.shop),
  [ShopOnboardingID.STAFF_ONBOARD]: constructPath(ROUTES.team),
  [ShopOnboardingID.PAYMENTS]: constructPath(ROUTES.payments),
  [ShopOnboardingID.BOOKING_LINK]: constructPath(ROUTES.bookingLinks),
  [ShopOnboardingID.WAIVERS]: constructPath(ROUTES.waivers),
  [ShopOnboardingID.SHOP_SETTINGS]: constructPath(ROUTES.shop, {
    tab: ShopTab.BOOKING,
  }),
  [ShopOnboardingID.BOOKING_MESSAGES]: constructPath(ROUTES.shop, {
    tab: ShopTab.CLIENT_MESSAGES,
  }),
  [ShopOnboardingID.ITEM_LIBRARY]: constructPath(ROUTES.items),
  [ShopOnboardingID.TERMINAL_READER]: constructPath(ROUTES.shop, {
    tab: ShopTab.TERMINAL,
  }),
  [ShopOnboardingID.IMPORT_DATA]: constructPath(ROUTES.import),
};

export const ONBOARDING_CATEGORY_NAMES: Record<
  NonNullable<OnboardingModalCategory>,
  string
> = {
  [ShopOnboardingCategory.ACTIVATE]: 'Activate your account',
  [ShopOnboardingCategory.CONFIGURE]: 'Configure shop settings',
  SETUP: 'Setup Guide',
};

export const ONBOARDING_SETUP_STEPS = [
  {
    id: ShopOnboardingCategory.ACTIVATE,
    name: 'Activate your account',
    category: ShopOnboardingCategory.ACTIVATE,
    isSkippable: false,
  },
  {
    id: ShopOnboardingCategory.CONFIGURE,
    name: 'Configure shop settings',
    category: ShopOnboardingCategory.CONFIGURE,
    isSkippable: false,
  },
];
